// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-line{flex-direction:row}@media(max-width: 991.98px){.project-line{flex-direction:column;margin-bottom:0px !important}}`, "",{"version":3,"sources":["webpack://./resources/app/modules/deals/DealOverlay/index.scss"],"names":[],"mappings":"AAAA,cACE,kBAAA,CAGF,4BACE,cACE,qBAAA,CACA,4BAAA,CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
